const appConfig = {
    name: process.env.REACT_APP_NAME || "Application",

    version: process.env.REACT_APP_VERSION || "1.0.0",

    basename: process.env.REACT_APP_BASENAME || ""
};

export default appConfig;
